import React, { useContext } from 'react';

import EditOwners from 'components/EditOwners';

import { addCollaboratorOwnerType, removeCommonToIdsFromOwners, selectCollaborators } from 'services/helpers/task';

import { EmployeesEditContext } from '.';

export default function CollaboratorsEdit({
  teamId,
  rightJustified = false,
  filterEmpIds = null,
  reactSelectComponentsOverride = {},
}) {
  const { employees, onUpdate } = useContext(EmployeesEditContext);
  const collaborators = selectCollaborators(employees);
  function onRemoveCollaborator(removedCollaborator, updatedCollaborators) {
    // remove the employee from list of employees
    const newEmployees = employees.filter((employee) => employee.id !== removedCollaborator.id);
    onUpdate(newEmployees);
  }

  function onUpdateCollaborator(collaborators) {
    if (!collaborators) return;
    const collaboratorsWithUpdatedOwnerType = addCollaboratorOwnerType(collaborators);
    const newEmployees = removeCommonToIdsFromOwners(employees, collaboratorsWithUpdatedOwnerType);
    onUpdate(newEmployees);
  }
  return (
    <EditOwners
      teamId={teamId}
      employees={collaborators}
      removeEmployee={onRemoveCollaborator}
      updateEmployees={onUpdateCollaborator}
      rightJustified={rightJustified}
      filterEmpIds={filterEmpIds}
      reactSelectComponentsOverride={reactSelectComponentsOverride}
    />
  );
}
